import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { QRCodeCanvas } from "qrcode.react";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { ArrowLeft, Printer } from "lucide-react";

export default function MelaBadges() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [mela, setMela] = useState(null);
  const [leads, setLeads] = useState([]);

  useEffect(() => {
    Promise.all([api.get("/melas"), api.get("/customers")]).then(([mr, cr]) => {
      const m = mr.data.find((x) => x.id === id);
      setMela(m);
      const invited = new Set(m?.invited || []);
      setLeads(cr.data.filter((c) => invited.has(c.id)));
    });
  }, [id]);

  return (
    <div data-testid="mela-badges-page">
      <div className="flex items-center justify-between mb-4 print:hidden">
        <button onClick={() => navigate("/app/mela")} className="flex items-center gap-1.5 text-sm text-slate-500 hover:text-slate-800" data-testid="badges-back-btn">
          <ArrowLeft size={15} /> Back to Loan Mela
        </button>
        <Button onClick={() => window.print()} className="bg-[#0A192F] hover:bg-[#0F4C81]" data-testid="badges-print-btn">
          <Printer size={16} className="mr-2" /> Print Badges
        </Button>
      </div>

      <div className="mb-4 print:mb-6">
        <h1 className="text-2xl font-bold text-slate-900" style={{ fontFamily: "Outfit, sans-serif" }}>{mela?.name || "Loan Mela"} — Check-in Badges</h1>
        <p className="text-sm text-slate-500">{leads.length} invited leads · {mela?.date} {mela?.venue ? `· ${mela.venue}` : ""}</p>
      </div>

      {leads.length === 0 ? (
        <div className="p-12 text-center text-slate-400" data-testid="badges-empty">No invited leads for this mela yet.</div>
      ) : (
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
          {leads.map((c) => (
            <div key={c.id} className="border border-slate-300 rounded-xl p-4 flex flex-col items-center text-center bg-white" data-testid={`badge-${c.id}`}>
              <div className="text-xs font-bold uppercase tracking-wider text-[#0A192F]">DIGI-LOANS Mela</div>
              <div className="my-3"><QRCodeCanvas value={c.id} size={128} level="M" /></div>
              <div className="font-semibold text-slate-900 leading-tight">{c.business_name}</div>
              <div className="text-xs text-slate-500 font-mono mt-0.5">{c.mobile}</div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
